import React, { Suspense, useState } from 'react';
import BalancePictorial from '../components/balance/BalancePictorial.jsx';

const tabs = [
  { key: 'pictorial', label: 'Pictorial' },
  { key: 'trends', label: 'Trends' },
  { key: 'summary', label: 'Summary (coming soon)', disabled: true },
];

const BalanceSheet = () => {
  const [active, setActive] = useState('pictorial');

  return (
    <div className="page">
      <div className="page-header" style={{display:'flex', alignItems:'center', justifyContent:'space-between', gap:16}}>
        <h1 style={{margin:0}}>Balance Sheet</h1>
        <div className="tabs" style={{display:'flex', gap:8, flexWrap:'wrap'}}>
          {tabs.map(t => (
            <button
              key={t.key}
              className={`btn ${active === t.key ? 'btn-primary' : 'btn-light'}`}
              onClick={() => !t.disabled && setActive(t.key)}
              disabled={t.disabled}
              style={{opacity: t.disabled ? 0.6 : 1}}
            >
              {t.label}
            </button>
          ))}
        </div>
      </div>

      <div style={{marginTop: 16}}>
        {active === 'pictorial' && <BalancePictorial />}
        {active === 'trends' && (
          <Suspense fallback={<div className="card"><div className="card-body">Loading trends…</div></div>}>
            <TrendsLazy />
          </Suspense>
        )}
        {active !== 'pictorial' && active !== 'trends' && (
          <div className="card"><div className="card-body">This view is coming soon.</div></div>
        )}
      </div>
    </div>
  );
};

export default BalanceSheet;

// Lazy load trends to avoid initial bundle weight
const TrendsLazy = React.lazy(() => import('../components/balance/BalanceTrends.jsx'));
